export default __webpack_public_path__ + "static/media/swarigamaLogo.58cf37b6.svg";